<template>
  <div class="home" @wheel="handleWheel">
    <Nav :isFirstPage="currentPage===1"></Nav>
    <transition :name="pageTransition" mode="out-in">
      <div class="page-container" ref="pageContainer">
        <div
            class="pages first-page"
            :style="{
            transform: `translateY(-${(currentPage - 1) * 100}vh)`
          }"
        >
          <!-- 使用v-for遍历所有页面 -->
          <div v-for="(page, index) in pages" :key="index" class="page">
            <div v-if="page === 'first'">
              <div class="banner">
                <div class="title">辽宁玖聚律师事务所</div>
                <div class="title1">
                  <div class="sub-title">玖明法理&nbsp&nbsp&nbsp聚之维权</div>
                  <div class="sub-title">同声相应&nbsp&nbsp&nbsp同气相求</div>
                </div>
              </div>
            </div>
            <div v-if="page === 'second'"><second-page @next-page="goNextPage"></second-page></div>
            <div v-if="page === 'third'"><third-page @next-page="goNextPage"></third-page></div>
            <div v-if="page === 'fourth'"><fourth-page @next-page="goNextPage"></fourth-page></div>
            <div v-if="page === 'fifth'"><fifth-page></fifth-page></div>
            <div v-if="page === 'footer'"><Footer></Footer></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Footer from "@/components/footer";
import Nav from "@/components/nav";
import FifthPage from "./fifthPage";
import FourthPage from "./fourthPage";
import ThirdPage from "./thirdPage";
import SecondPage from "./secondPage";

export default {
  name: "HelloWorld",
  components: {
    Footer,
    FifthPage,
    FourthPage,
    ThirdPage,
    SecondPage,
    Nav
  },
  data() {
    return {
      currentPage: 1, // 当前页面
      lastWheelTime: 0, // 上次滚动时间
      pageTransition: 'page-slide-enter-active', // 动态修改过渡类名
      direction: 'down', // 记录翻页的方向，'down' 或 'up'
      pages: ['first', 'second', 'third', 'fourth', 'fifth', 'footer'] // 页面数组，简化页面的管理
    };
  },
  methods: {
    handleWheel(event) {
      const currentTime = Date.now();
      const timeDifference = currentTime - this.lastWheelTime;
      const scrollThreshold = 250;
      const distanceThreshold = 200;

      if (timeDifference < scrollThreshold) {
        if (event.deltaY > distanceThreshold && this.currentPage < 6) {
          this.direction = 'down';
          this.$nextTick(() => {
            this.currentPage++;
          });
        } else if (event.deltaY < -distanceThreshold && this.currentPage > 1) {
          this.direction = 'up';
          this.$nextTick(() => {
            this.currentPage--;
          });
        }
      } else {
        if (event.deltaY > 0 && this.currentPage < 6) {
          this.direction = 'down';
          this.$nextTick(() => {
            this.currentPage++;
          });
        } else if (event.deltaY < 0 && this.currentPage > 1) {
          this.direction = 'up';
          this.$nextTick(() => {
            this.currentPage--;
          });
        }
      }

      this.pageTransition = this.direction === 'down' ? 'page-slide-down' : 'page-slide-up';
      this.lastWheelTime = currentTime;
    },
    goNextPage() {
      if (this.currentPage < 6) {  // 如果当前页面不是最后一页
        this.currentPage++;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  height: 100%; /* 确保父容器高度为 100% */
  overflow: hidden; /* 禁止滚动条 */
}

.page-container {
  height: 100%;
}

.pages {
  display: flex;
  flex-direction: column;
  transition: transform 0.8s ease-in-out;
  height: 600%; /* 确保包含所有页面 */
}

.page {
  height: 100%;
  width: 100%;
}

.first-page {
  position: relative;
  height: 100%;
  .icon {
    position: absolute;
    bottom: 5vh;
    right: 10vw;
    z-index: 10;
  }
  .title {
    width: 100%;
    font-weight: 500;
    font-size: 124px;
    color: #FFFFFF;
    line-height: 116px;
    text-align: center;
    z-index: 100;
  }
  .sub-title{
    display: inline-block;
    font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;
    font-weight: normal;
    font-size: 40px;
    color: #FFFFFF;
    line-height: 116px;
    z-index: 100;
    margin-top: 24px;
    padding: 0 170px;
  }
  .one-page{
    position: absolute;
    z-index: 100;
    bottom: 4vh;
    left: 10vw;
    color: #FFFFFF;
    font-size: 12px;
    line-height: 12px;
  }
}


.page-slide-down-enter-active, .page-slide-down-leave-active {
  transition: transform 0.8s ease-in-out;
}

.page-slide-down-enter {
  transform: translateY(100%); /* 页面从下方进入 */
}

.page-slide-down-leave-to {
  transform: translateY(-100%); /* 页面向下离开 */
}

.page-slide-up-enter-active, .page-slide-up-leave-active {
  transition: transform 0.8s ease-in-out;
}

.page-slide-up-enter {
  transform: translateY(-100%); /* 页面从上方进入 */
}

.page-slide-up-leave-to {
  transform: translateY(100%); /* 页面向上离开 */
}

.page-slide-down-enter-active, .page-slide-up-enter-active {
  z-index: 10;  // 让进入的页面位于最上层
}

.page-slide-down-leave-active, .page-slide-up-leave-active {
  z-index: 0;   // 离开的页面位于最下层
}
/* 修改banner样式，确保它能正确显示 */
.banner {
  width: 100%;
  height: 100vh; /* 使用视口高度确保占满屏幕 */
  background: url(../../assets/homePage/banner.png) no-repeat center;
  background-size: cover;
  position: relative; /* 确保内部元素可以绝对定位 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* 检查first-page样式 */
.first-page {
  position: relative;
  height: 100vh; /* 改为视口高度 */
  width: 100%; /* 确保宽度正确 */
}
</style>
